import {Row, Col} from 'react-bootstrap';
import "./DataDownloadTile.css";

const MultiDataDownloadTile = (props) => {

  const handle_download = (e) => {
    e.preventDefault();
    props.url.forEach((url) => {                
      fetch(url).then(
        res => {
          window.open(res.url);
        }
      );                           
    });
  };

  return(
    <div className="data-download-tile">
      <Row>
        <Col
          xs={12}
          sm={12}
          md={3}
          lg={3} >
          <div className="download-icon-border">
            <img src="./images/download-icon@2x.png" alt="download-icon" onClick={handle_download} />
          </div>
        </Col>
        <Col
          xs={12}
          sm={12} 
          md={{span: 9, offset: 0}} 
          lg={{span: 9, offset: 0}} >
          <div className="download-tile-headers">
            <span className="download-tile-header1">Download</span>
            <span className="download-tile-header2">
              <span className="new-data-note">NEW</span>
              {" " + props.title}
            </span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col
        xs={12}
        sm={12} 
        md="auto" 
        lg="auto" >
          <div className="download-tile-content multi-file-download">
            <span className="download-tile-content2">
              <p>
                The Track 1 datasets are split into 3 separate .zip files, each containing one third of the 
                datasets. Allow pop-ups for this web page in your browser in order download all 3 .zip files at once.
              </p>
                If above does not work, or pop-ups are disabled, download data using the URLs:<br/>
              <a id="track1a" className='url-text' href={window.location.href + props.url[0].replace('./data', '')}>
                track1 part1
              </a>; <a id="track1b" className='url-text' href={window.location.href + props.url[1].replace('./data', '')}>
                track1 part2
              </a>; <a  id="track1c" className='url-text' href={window.location.href + props.url[2].replace('./data', '')}>
                track1 part3
              </a>
            </span>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default MultiDataDownloadTile;
